<template>
  <div style="width:1180px;margin:50px auto;background-color:#FFF;">
    <!-- Modal -->
    <div class="modal fade" id="myModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">Message</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <template v-for="(errMsg, index) in errMsgs">
              <div >
                {{ errMsg }}
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button v-show="modalType == 'error'" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button v-show="modalType == 'toPage1'" type="button" class="btn btn-secondary" data-bs-dismiss="modal" v-on:click="toPage1">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- loading -->
    <div class="loading" v-show="pageLoading">
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>

    <div v-if="page == 1 && isSSO == true">
      <div style="margin:20px 0px;text-align: left;font-weight: 510;font-size: 22px;line-height: 21px;">標籤
          <div style="display: inline;" data-bs-toggle="tooltip" data-bs-placement="top" title="若此標籤已使用在已啟動的Journey內，再修改此標籤，不會同步更新Journey內的標籤設定">
            <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size:16px;"/>
          </div>
      </div>
      <div>
        <form class="d-flex" onkeypress="return event.keyCode != 13">
            <div class="d-flex flex-row position-relative" style="width:50%;">
              <input type="text" class="form-control" id="example-search-input" v-model="searchText" v-on:keyup="keyUpFun">
              <button class="btn border-0 position-absolute end-0" type="button" v-on:click="search">
                <font-awesome-icon icon="a-solid fa-magnifying-glass" />
              </button>
            </div>
            <span style="width:40%;">&nbsp;</span>
            <button type="button" class="btn btn-light" style="width:10%;background-color:#fff;color:#2C70CB;border: 1px solid #cccccc;font-weight: 500;" v-on:click="addTag">+  新增標籤</button>
        </form>
        <div v-show="true" style="height:calc(100% - 20px);padding: 10px 0px;">
          <div id="tableList" style="height: calc(100%);">
              <el-table
                  class="elTable"
                  v-loading="listLoading"
                  v-bind:data="tagList"
                  element-loading-text="Loading"
                  v-bind:header-cell-style="{ background: '#FFF', color: '#606266', borderBottom: '1px solid #CCCCCC' }"
                  min-height="100%"
                  style="width:100%;height: 100%;overflow: auto;"
              >
                  <el-table-column prop="tagName" label="標籤名稱" min-width="60%">
                      <template slot-scope="tag">
                          <span>
                          {{ tag.row.name }}
                          </span>
                      </template>
                  </el-table-column>
                  <el-table-column prop="date" label="建立日期" min-width="30%">
                      <template slot-scope="tag">
                          <span>
                          {{ tag.row.CreatedAt }}
                          </span>
                      </template>
                  </el-table-column>
                  <el-table-column label="動作" min-width="10%">
                      <template slot-scope="scope">
                        <el-button v-on:click="copyTag(scope.row)" type="text" size="small">Copy</el-button>
                        <el-button v-on:click="editTag(scope.row)" type="text" size="small">Edit</el-button>
                      </template>
                  </el-table-column>
              </el-table>
          </div>
          <el-pagination
              v-on:size-change="handleSizeChange1"
              v-on:current-change="handleCurrentChange1"
              v-bind:current-page="currentListPage"
              v-bind:pager-count="11"
              v-bind:total="total"
              layout="->, prev, pager, next"
              style="height:40px;padding:10px 0px 0px 0px;">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- Insert -->
    <div v-if="page == 2 && isSSO == true" style="display: flex; flex-direction: column;border: 1px solid #E4E4E4;border-radius: 10px;">
      <div style="margin:20px;text-align: left;font-weight: 510;font-size: 22px;line-height: 21px;">{{page2Title}}
          <div style="display: inline;" data-bs-toggle="tooltip" data-bs-placement="top" title="若此標籤已使用在已啟動的Journey內，再修改此標籤，不會同步更新Journey內的標籤設定">
            <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size:12px;"/>
          </div>
      </div>
      <div>
        <hr style="border: 0;width:100%;margin:0px 0px 10px;height:1px;background-color:#A6A6A6;color:#A6A6A6;" />
      </div>
      <!-- 中間填寫區域 -->
      <div style="display: flex; flex-wrap: wrap;">
        <div class="rowdiv">
          <div class="rowdiv_div1">標籤日期<span style="color: red;">*</span>
            <div style="display: inline;" data-bs-toggle="tooltip" data-bs-placement="top" title="請輸入Journey預計開始/啟動的日期">
              <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size:12px;"/>
            </div>
          </div>
          <div>
            <input style="height: 44px;" type="date" v-model="date" v-bind:class="[{ 'form-control': true }, { 'is-invalid': this.dateError != '' }]"/>
            <div v-show="this.dateError != ''" class="invalid-feedback">
              {{ dateError }}
            </div>
          </div>
        </div>
        <div class="rowdiv">
          <div class="rowdiv_div1">發送渠道<span style="color: red;">*</span></div>
          <div>
            <select style="height: 44px;" v-model="channel" v-bind:class="[{ 'form-select': true }, { 'is-invalid': this.channelError != '' }]">
              <option
                v-for="channel in channels"
                v-bind:key="channel"
                v-bind:value="channel"
                v-text="channel"
              ></option>
            </select>
            <div v-show="this.channelError != ''" class="invalid-feedback">
              {{ channelError }}
            </div>
          </div>
        </div>
        <div class="rowdiv">
          <div class="rowdiv_div1">Campaign 名稱<span style="color: red;">*</span>
            <div style="display: inline;" data-bs-toggle="tooltip" data-bs-placement="top" title="請勿輸入半形特殊符號，如: , ; : ' * &quot; ? / - &amp; $ # @ | = ^">
              <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size:12px;"/>
            </div>
          </div>
          <div>
            <input type="text" v-model="campaignName" v-bind:class="[{ 'form-control': true }, { 'is-invalid': this.campaignNameError != '' }]"/>
            <div v-show="this.campaignNameError != ''" class="invalid-feedback">
                {{ campaignNameError }}
            </div>
          </div>
        </div>
        <div class="rowdiv">
          <div class="rowdiv_div1">動作類型<span style="color: red;">*</span></div>
          <div>
            <select style="height: 44px;" v-model="actionType" v-bind:class="[{ 'form-select': true }, { 'is-invalid': this.actionTypeError != '' }]">
              <option
                v-for="actionType in actionTypes"
                v-bind:key="actionType"
                v-bind:value="actionType"
                v-text="actionType"
              ></option>
            </select>
            <div v-show="this.actionTypeError != ''" class="invalid-feedback">
              {{ actionTypeError }}
            </div>
          </div>
        </div>
        <div class="rowdiv">
          <div class="rowdiv_div1">內容<span style="color:red;font-size:12px;">&nbsp;&nbsp;
            <div style="display: inline;color:#000;" data-bs-toggle="tooltip" data-bs-placement="top" title="請勿輸入半形特殊符號，如: , ; : ' * &quot; ? / - &amp; $ # @ | = ^">
              <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size:12px;"/>
            </div>
            &nbsp;&nbsp;「內容」與「產品」請至少則一填寫</span>
          </div>
          <div>
            <input type="text" v-model="content" v-bind:class="[{ 'form-control': true }, { 'is-invalid': this.contentError != '' }]"/>
            <div v-show="this.contentError != ''" class="invalid-feedback">
                {{ contentError }}
              </div>
          </div>
        </div>
        <div class="rowdiv">
          <div class="rowdiv_div1">離開旅程
            <div style="display: inline;" data-bs-toggle="tooltip" data-bs-placement="top" title="若核取Leave Journey選項後，Tag Name結尾會自動加上_Leave">
              <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size:12px;"/>
            </div>
          </div>
          <div><input class="rowdiv_div2" style="width: 30px;" type="checkbox" v-model="leaveJourney"/></div>
        </div>
        <div class="rowdiv">
          <div class="rowdiv_div1">產品<span style="color:red;font-size:12px;">&nbsp;&nbsp;「內容」與「產品」請至少則一填寫</span></div>
          <div>
            <select style="height: 44px;" v-model="product" v-bind:class="[{ 'form-select': true }, { 'is-invalid': this.productError != '' }]">
              <option
                v-for="product in products"
                v-bind:key="product"
                v-bind:value="product"
                v-text="product"
              ></option>
            </select>
            <div v-show="this.productError != ''" class="invalid-feedback">
                {{ productError }}
            </div>
          </div>
        </div>
        <div class="rowdiv">
          <div class="rowdiv_div1">標籤名稱</div>
          <div><input class="rowdiv_div2" type="text" style="background: #ccc;" v-model="tagName" :disabled="true"/></div>
        </div>
      </div>
      <div>
        <hr style="border: 0;width:100%;margin:0px 0px 10px;height:1px;background-color:#A6A6A6;color:#A6A6A6;" />
      </div>
      <div style="">
        <button type="button" class="btn btn-primary" style="float: right;margin: 10px 20px 20px;background-color:#003968;" v-on:click="save"> Save</button>
        <button type="button" class="btn btn-light" style="float: right;margin: 10px 20px 20px;background-color:#FFF;color:#003968;" v-on:click="cancel">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { doAuth, doAuth2 } from '@/api/authorized'
import { getTagList, getListByKey, insertListById, upsertListById } from '@/api/tag'
import { getProductList } from '@/api/product'
export default {
  name: 'TagTemplate',
  data: function () {
    return {
      pageLoading: true,
      modalType: '',
      page: 1,
      // Page1 - List
      searchText: '',
      listLoading: false,
      currentListPage: 1,
      pageSize: 10,
      total: 0,
      pagerCount: 0,
      allTagList: [{'tagName': '20230118_火鍋_紅茶_App_Open_Leave', 'date': '2023/01/01', 'channel': 'App', 'actionType': 'Open'}, {'tagName': '20230118_火鍋_奶茶_App_Open_Leave', 'date': '2023/01/02'}],
      tagList: [],
      // Page2 - insert
      page2Title: '',
      model: '',
      tagId: '',
      date: '',
      campaignName: '',
      content: '',
      product: '',
      products: ['紅茶', '綠茶'],
      channel: '',
      channels: ['App', 'SMS', 'EDM'],
      actionType: '',
      actionTypes: ['Open', 'Click', 'Sample Request', 'Purchase'],
      leaveJourney: false,
      tagName: '',
      // Page2 - Error
      errMsgs: '',
      dateError: '',
      campaignNameError: '',
      contentError: '',
      productError: '',
      channelError: '',
      actionTypeError: '',
      // SSO
      isSSO: false,
      host: '',
      redirectPage: '',
      code: null,
      redirectUrl: '',
      pageName: 'tag', //改成後端的名稱
      token: '',
      refreshToken: ''
    }
  },
  watch: {
    // campaignName: function () {
    //   this.campaignName = this.campaignName.replace('“', '').replace('”', '')
    // }
  },
  created () {
    this.host = process.env.VUE_SERVER_DOMAIN
    this.redirectPage = this.$route.query.redirect == undefined ? 'tag' : this.$route.query.redirect;
    if (this.redirectPage == null && this.code == null) {
      alert('登錄資訊錯誤');
      return;
    }

    this.redirectUrl = "https://" + this.host + "/tag?redirect=" + this.redirectPage.replace("/", "")
    this.code = this.$route.query.code == undefined ? 0 : this.$route.query.code;
    
    if (this.code != 0) {
      let req = {
        page: this.redirectPage,
        code: this.code,
        redirect_uri: this.redirectUrl
      };
      doAuth2(req).then(res => {
        if (res.Success) {
          if (res.AccessToken) {
            //this.$store.dispatch("resetToken", res.AccessToken.access_token);
            //this.$store.dispatch("resetRefreshToken", res.AccessToken.refresh_token);
            this.token = res.AccessToken.access_token;
            this.refreshToken = res.AccessToken.refresh_token;
            this.isSSO = true;
            this.$router.push(this.redirectPage).catch(() => {});
            this.fetchData();
            this.getProductData();
            this.pageLoading = false;
          }
        }
      });
    } else if (this.redirectPage != null && this.code == 0) {
      let req = {
        page: this.redirectPage
      };
      doAuth(req).then(res => {
        if (res.Success) {
          let targetUrl = res.TargetUrl.replace(
            "{{redirect_url}}",
            this.redirectUrl
          );
          window.location.href = targetUrl
        }
      });
    }
  },
  mounted () {
    this.initTooltip()
    // this.currentChangePage(this.allTagList, this.currentListPage)
    //改成在取得Token之後才做
    //this.fetchData()
    //this.getProductData()
  },
  updated () {
    if (this.date !== '' && this.campaignName !== '' && (this.content !== '' || this.product !== '') && this.channel !== '' && this.actionType !== '') {
      let contentProduct = (this.content !== '' && this.product !== '') ? this.content + '_' + this.product : (this.content !== '' && this.product === '') ? this.content : this.product
      let tmpTagName = this.date.replaceAll('-', '') + '_' + this.campaignName + '_' + contentProduct + '_' + this.channel + '_' + this.actionType
      if (this.leaveJourney === true) {
        tmpTagName = tmpTagName + '_Leave'
      }
      this.tagName = tmpTagName
    }
    else
      this.tagName = ''
  },
  methods: {
    search: function () {
      this.listLoading = true
      if (this.searchText === '') {
        let req = {}
        req.pageName = this.pageName
        req.token = this.token
        req.refreshToken = this.refreshToken
        getTagList(req).then((res) => {
          //token
          this.token =  res.token.access_token
          this.refreshToken =  res.token.refresh_token
          //資料
          this.allTagList = res.tagList
          this.fixfetchData()
          this.currentListPage = 1
          this.currentChangePage(this.allTagList, this.currentListPage)
          this.listLoading = false
        })
      } else {
        let req = {}
        req.pageName = this.pageName
        req.token = this.token
        req.refreshToken = this.refreshToken
        getListByKey(req, this.searchText).then((res) => {
          //token
          this.token =  res.token.access_token
          this.refreshToken =  res.token.refresh_token
          //資料
          this.allTagList = res.tagList
          this.fixfetchData()
          this.currentListPage = 1
          this.currentChangePage(this.allTagList, this.currentListPage)
          this.listLoading = false
        })
      }
    },
    checkContent: function (value) {
      // eslint-disable-next-line no-useless-escape
      let reg = /[`~!@#|$%^&*()+=<>\-?:"{}\\,.\/;'[\]]/im
      if (reg.test(value)) {
        return false
      } else {
        return true
      }
    },
    cancel: function () {
      this.page = 1
      this.initTooltip()
    },
    save: function () {
      let errMsgs = []
      this.dateError = ''
      this.campaignNameError = ''
      this.contentError = ''
      this.productError = ''
      this.channelError = ''
      this.actionTypeError = ''
      if (this.date === '') {
        errMsgs.push('請填入標籤日期')
        this.dateError = '請填入標籤日期'
      }
      if (this.campaignName === '') {
        errMsgs.push('請填入Campaign 名稱')
        this.campaignNameError = '請填入Campaign 名稱'
      } else if (this.campaignName !== '' && !this.checkContent(this.campaignName)) {
        errMsgs.push('請勿輸入半形特殊符號，如: , ; : * ' + "'" + ' " ? / - & $ # @ | = ^')
        this.campaignNameError = '請勿輸入半形特殊符號，如: , ; : * ' + "'" + ' " ? / - & $ # @ | = ^'
      }
      if (this.channel === '') {
        errMsgs.push('請填入發送渠道')
        this.channelError = '請填入發送渠道'
      }
      if (this.actionType === '') {
        errMsgs.push('請填入動作類型')
        this.actionTypeError = '請填入動作類型'
      }
      if (this.content === '' && this.product === '') {
        errMsgs.push('請填入內容或產品')
        this.contentError = '請填入內容或產品'
        this.productError = '請填入內容或產品'
      }

      if (errMsgs.length === 0) {
        if (this.model === 'insert' || this.model === 'copy' || this.model === 'edit') {
          let req = {}
          req.pageName = this.pageName
          req.token = this.token
          req.refreshToken = this.refreshToken
          req.ID = 0
          if (this.tagId !== '') {
            req.ID = parseInt(this.tagId, 10)
          }
          req.Name = this.tagName
          req.Source = 'SFMC'
          req.CampaignName = this.campaignName
          req.Content = this.content
          req.Product = this.product
          req.Channel = this.channel
          req.ActionType = this.actionType
          req.LeaveJourney = this.leaveJourney.toString()
          req.Date = this.date + 'T00:00:00Z'

          if (req.ID === 0) {
            insertListById(req).then((res) => {
              if (res.err === null) {
                //token
                this.token =  res.token.access_token
                this.refreshToken =  res.token.refresh_token
                let errMsgs = []
                this.modalType = 'toPage1'
                errMsgs.push('新增成功')
                this.showModal(errMsgs)
              }
            }).catch((err) => {
              console.log('err', err)
              if (err.response.data.code === 3000) { errMsgs.push('已存在相同標籤名稱，請重新輸入') } else { errMsgs.push(err.response.message) }
              this.modalType = 'error'
              this.showModal(errMsgs)
            })
          } else if (req.ID !== 0) {
            upsertListById(req).then((res) => {
              if (res.err === null) {
                let errMsgs = []
                this.modalType = 'toPage1'
                errMsgs.push('更新成功')
                this.showModal(errMsgs)
              }
            }).catch((err) => {
              errMsgs.push(err.response.message)
              this.modalType = 'error'
              this.showModal(errMsgs)
            })
          }
        }
      } else {
        this.modalType = 'error'
        this.showModal(errMsgs)
      }
    },
    showModal: function (errMsgs) {
      // eslint-disable-next-line no-undef
      const myModal = new bootstrap.Modal(document.getElementById('myModal'))
      this.errMsgs = errMsgs
      myModal.show()
    },
    initTooltip: function () {
      setTimeout(function () {
        var tooltipTriggerList = [].slice.call(
          document.querySelectorAll('[data-bs-toggle="tooltip"]')
        )
        // eslint-disable-next-line no-unused-vars
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
          // eslint-disable-next-line no-undef
          return new bootstrap.Tooltip(tooltipTriggerEl)
        })
      }, 200)
    },
    toPage1: function () {
      this.fetchData()
      this.page = 1
    },
    getProductData: function () {
      let req = {
        token: this.token,
        refreshToken: this.refreshToken
      };

      getProductList(req).then((res) => {
        if (res !== null) {
          this.products = []
          for (let i = 0; i < res.length; i++) {
            this.products.push(res[i].Name)
          }
        }
      }).catch((err) => {
        let errMsgs = []
        errMsgs.push(err.response.message)
        this.modalType = 'error'
        this.showModal(errMsgs)
      })
    },
    fetchData (pageSize, currentListPage) {
      this.listLoading = true
      let req = {}
      req.pageName = this.pageName
      req.token = this.token
      req.refreshToken = this.refreshToken
      getTagList(req).then((res) => {
        //token
        this.token =  res.token.access_token
        this.refreshToken =  res.token.refresh_token
        //資料
        for (let i = 0; i < res.tagList.length; i++) {
          res.tagList[i].CreatedAt = res.tagList[i].CreatedAt.substring(0, res.tagList[i].CreatedAt.indexOf('T'))
          res.tagList[i].CreatedAt = res.tagList[i].CreatedAt.replaceAll('-', '/')
        }
        this.allTagList = res.tagList
        this.total = this.allTagList.length - 1
        this.fixfetchData()
        this.currentListPage = 1
        this.currentChangePage(this.allTagList, this.currentListPage)
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        const errMsgs = []
        errMsgs.push('網路連線異常')
        this.modalType = 'error'
        this.showModal(errMsgs)
      })
    },
    fixfetchData () {
      for (let i = 0; i < this.allTagList.length; i++) {
        // 建立日期
        if (this.allTagList[i].CreatedAt !== undefined && this.allTagList[i].CreatedAt !== null) {
          let d = new Date(this.allTagList[i].CreatedAt)
          let Y = d.getFullYear() + '-'
          let M = (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-'
          let D = (d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate())
          // let h = (date.getHours() < 10 ? "0" + (date.getHours()) : date.getHours()) + ":"
          // let m = (date.getMinutes() < 10 ? "0" + (date.getMinutes()) : date.getMinutes()) + ":"
          // let s = (date.getSeconds() < 10 ? "0" + (date.getSeconds()) : date.getSeconds())
          this.allTagList[i].showCreateDate = Y + M + D
        }
        // 標籤日期
        if (this.allTagList[i].date !== undefined && this.allTagList[i].date !== null) {
          let d = new Date(this.allTagList[i].date)
          let Y = d.getFullYear() + '-'
          let M = (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-'
          let D = (d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate())
          this.allTagList[i].showDate = Y + M + D
        }
      }
    },
    handleSizeChange1: function (pageSize) {
      // 每頁條數切换
      this.pageSize = pageSize
      this.handleCurrentChange1(1)
    },
    handleCurrentChange1: function (currentPage) {
      // 頁碼切换
      this.currentListPage = currentPage
      this.currentChangePage(this.allTagList, this.currentListPage)
    },
    // 分頁方法（重點）
    currentChangePage (tempList, currentPage) {
      let from = 0
      if (currentPage !== 1) {
        from = (currentPage - 1) * this.pageSize
      }
      let to = currentPage * this.pageSize
      this.tagList = []
      for (; from < to; from++) {
        if (tempList[from]) {
          this.tagList.push(tempList[from])
        }
      }
    },
    addTag () {
      this.page2Title = '新增標籤資訊'
      this.model = 'insert'

      this.tagId = ''
      this.date = ''
      this.campaignName = ''
      this.content = ''
      this.product = ''
      this.channel = ''
      this.actionType = ''
      this.leaveJourney = ''
      this.tagName = ''

      this.page = 2
      this.initTooltip()
    },
    copyTag (row) {
      this.page2Title = '複製標籤資訊'
      this.model = 'copy'

      this.tagId = ''
      // if (row.date !== undefined && row.date !== null) {
      //   const d = new Date(row.date)
      //   this.date = (row.date !== undefined && row.date !== null) ? d.getFullYear() + '-' + d.getMonth() + 1 + '-' + d.getDate() : '' // .replaceAll('/', '-')
      // } else { this.date = '' }
      this.date = row.showDate
      this.campaignName = (row.campaignName !== undefined && row.campaignName !== null) ? row.campaignName : ''
      this.content = (row.content !== undefined && row.content !== null) ? row.content : ''
      this.product = (row.product !== undefined && row.product !== null) ? row.product : ''
      this.channel = (row.channel !== undefined && row.channel !== null) ? row.channel : ''
      this.actionType = (row.actionType !== undefined && row.actionType !== null) ? row.actionType : ''
      if (row.leaveJourney !== undefined && row.leaveJourney !== null) {
        this.leaveJourney = row.leaveJourney === 'true'
      } else {
        this.leaveJourney = false
      }
      this.tagName = ''

      this.page = 2
      this.initTooltip()
    },
    editTag (row) {
      this.page2Title = '編輯標籤資訊'
      this.model = 'edit'

      this.tagId = row.id
      this.date = row.showDate
      this.campaignName = (row.campaignName !== undefined && row.campaignName !== null) ? row.campaignName : ''
      this.content = (row.content !== undefined && row.content !== null) ? row.content : ''
      this.product = (row.product !== undefined && row.product !== null) ? row.product : ''
      this.channel = (row.channel !== undefined && row.channel !== null) ? row.channel : ''
      this.actionType = (row.actionType !== undefined && row.actionType !== null) ? row.actionType : ''
      if (row.leaveJourney !== undefined && row.leaveJourney !== null) {
        this.leaveJourney = row.leaveJourney === 'true'
      } else {
        this.leaveJourney = false
      }
      this.tagName = ''

      this.page = 2
      this.initTooltip()
    },
    keyUpFun: function(e) {
      if (e.keyCode === 13) {
        // console.log('Enter was pressed');
        this.search();
      } else if (e.keyCode === 50) {
        // console.log('@ was pressed');
      }
    }
  }
}
</script>

<style scoped>
.elTable {
  border: 1px solid #E4E4E4;
  border-radius: 10px;
}
.rowdiv {
  width:calc(50% - 0px);
  text-align: left;
  padding:15px 20px;
}
.rowdiv_div1 {
  margin-bottom: 4px;
}
.rowdiv_div2 {
  width:100%;
  height:40px;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  padding: 0px 10px;
}

.loading {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: .5;
}

.spinner-border {
  margin-top: 30%;
  width: 5rem;
  height: 5rem;
}
</style>
